import React, { useContext } from 'react';
import styled from 'styled-components';
import { Container } from './SliderViewModeSwitch';
import { ConfigureButton } from './ConfigureButton';
import { FAStateContext } from '../context/FAStateContext';

const ButtonWrapper = styled.div`
  display: none;
  @media (min-width: ${(props) => props.theme.breakpoints.xl}px) {
    display: flex;
    justify-content: center;
  }
`;
export const StageConfigureButton: React.FC = () => {
  const { viewMode } = useContext(FAStateContext);

  if (viewMode !== 'slides') return null;
  return (
    <ButtonWrapper>
      <Container stageConfigBtn>
        <ConfigureButton />
      </Container>
    </ButtonWrapper>
  );
};
